function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import { Component, cloneElement } from "react";
export const TooltipSourceRef = "TooltipSource";
export default class TooltipSource extends Component {
  render() {
    const {
      children,
      ...rest
    } = this.props;
    return /*#__PURE__*/cloneElement(children, rest);
  }

}

_defineProperty(TooltipSource, "typeRef", TooltipSourceRef);